import { ControlResultColumnResponseDtoType } from "@/spz-api/model";
import { OperatorEnum } from "@spz/shared-domain";
import type { ColumnFiltersState } from "@tanstack/react-table";
import {
  type IntergerFilterValueItem,
  getIntegerFilterValue,
} from "./values/integer-filter-value";
import {
  type MonetaryFilterValueItem,
  getMonetaryFilterValue,
} from "./values/monetary-filter-value";
import {
  type ShortDateValueItem,
  getShortDateFilterValue,
} from "./values/short-date-filter-value";

export function buildApiFilters(
  columnFilters: ColumnFiltersState,
  columnTypes: Record<string, string>,
) {
  return JSON.stringify({
    filters: columnFilters
      .map((f) => {
        if (!f.id || f.value === undefined || f.value === "") return null;

        const type = columnTypes[f.id]?.toLowerCase();

        if (Array.isArray(f.value)) {
          // numeric range (INTEGER, MONETARY)
          if (
            type === ControlResultColumnResponseDtoType.INTEGER.toLowerCase()
          ) {
            const [min, max] = f.value as IntergerFilterValueItem[];
            return getIntegerFilterValue({ column: f.id, min, max });
          }

          if (
            type === ControlResultColumnResponseDtoType.MONETARY.toLowerCase()
          ) {
            const [min, max] = f.value as MonetaryFilterValueItem[];
            return getMonetaryFilterValue({ column: f.id, min, max });
          }

          // date range (SHORT_DATE)
          if (
            type === ControlResultColumnResponseDtoType.SHORT_DATE.toLowerCase()
          ) {
            const [min, max] = f.value as ShortDateValueItem[];
            return getShortDateFilterValue({ column: f.id, min, max });
          }
        }

        // Multiple values (IN operator)
        if (Array.isArray(f.value)) {
          return {
            column: f.id,
            operator: OperatorEnum.IN,
            value: f.value,
          };
        }

        // Single value (text)
        switch (type) {
          case ControlResultColumnResponseDtoType.TEXT.toLowerCase():
            return {
              column: f.id,
              operator: OperatorEnum.CONTAINS_SUBSTR,
              value:
                Array.isArray(f.value) && f.value.length === 1
                  ? f.value[0]
                  : f.value,
            };

          default:
            return { column: f.id, operator: OperatorEnum.EQ, value: f.value };
        }
      })
      .filter(Boolean),
  });
}
